<div>
  <div class="form-group">
    <label for="rolName">Role Name:</label>
    <input
      type="text"
      class="form-control"
      id="editNameRole"
      readonly
      [(ngModel)]="selectedRole.rolName"
    />
  </div>

  <div class="permissions-container">
    <div *ngFor="let group of permissionGroups" class="permission-group">
      <h5 class="group-header">{{ group }}</h5>
      <div class="permissions-list">
        <div *ngFor="let permission of groupedPermissions[group]" style="margin-bottom: 8px">
          <p-checkbox
            [value]="permission.name"
            [(ngModel)]="selectedCategories"
            [inputId]="permission.id"
            (onChange)="onPermissionChange()"
          ></p-checkbox>
          <label
            [for]="permission.key"
            class="permission-name"
            style="margin-bottom: 0; margin-left: 8px"
            >{{ permission.name }}</label
          >
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button (click)="deleteRole()" type="button" title="Delete" class="btn btn-danger">Delete</button>
  <button (click)="updateRole()" type="button" title="Save" class="btn btn-primary">Save</button>
  <button (click)="close()" type="button" title="Close" class="btn">Close</button>
</div>
